export default __webpack_public_path__ + "static/media/27.6254296f.jpg";